// Read (display/edit) mapping — a superset. The provider owns the mediaJobs collection and feeds
// BOTH the show-page Employment section and the edit modal, so deserialized rows carry the
// display-only outlet fields the section renders (outlet slug + display name + logo) in addition to
// the editable fields. `getAllByMediaProfile` selects all view columns, so these are already fetched.
// Read nuance: the outlet's display name lives in the view column `media_outlet_display_name`
// (the outlet's own display string), which we expose under the simpler `mediaOutletName` here.
const readMapping = {
  id: "id",
  mediaOutletId: "media_outlet_id",
  mediaOutletName: "media_outlet_display_name",
  mediaOutletSlug: "media_outlet_slug",
  mediaOutletMigrateId: "media_outlet_migrate_id",
  mediaOutletProfileImageUrl: "media_outlet_profile_image_url",
  title: "title",
  from: "started_at",
  to: "ended_at",
};

// Write mapping — exactly the four fields Id::MediaJobPolicy allowlists for a create/update
// (title, media_outlet_id, started_at, ended_at), plus an `id` passthrough the callers strip. The
// denormalized outlet display fields (slug, display name) are read-only and stay out of the payload.
// Like the PR-side employment serializer, the related entity is referenced by id alone
// (`media_outlet_id`); outlet creation happens separately (qapi.mediaOutlets.create) in the picker,
// mirroring how a new company is created via qapi.companies.create before a PR job write.
const writeMapping = {
  id: "id",
  mediaOutletId: "media_outlet_id",
  title: "title",
  from: "started_at",
  to: "ended_at",
};

// Serializes a media job model object for a write, transforming camelCase keys to the API's
// snake_case (e.g. { mediaOutletId: 123 } -> { media_outlet_id: 123 }) over the writable subset only.
export function serializeModel(model) {
  return Object.keys(writeMapping).reduce((acc, key) => {
    acc[writeMapping[key]] = model[key];
    return acc;
  }, {});
}

// Deserializes an API row to a camelCase model over the full read mapping.
export function deserializeModel(model) {
  return Object.keys(readMapping).reduce((acc, key) => {
    acc[key] = model[readMapping[key]];
    return acc;
  }, {});
}
